document.addEventListener("DOMContentLoaded", function () {
    const ss_ll_prms = new URLSearchParams(window.location.search);
    const slpr = ss_ll_prms.get('ss_ll_mvcnf');
    if(slpr == "d3bl_sa1854"){var slpr_cnf = "true";}else{var slpr_cnf = "false";};
    ss_line_conb(slpr_cnf);
});
async function ss_line_conb(slpr_cnf_v){
    try {
        await liff.init({ liffId: "2008845471-yxaksQcH" });
        if (!liff.isLoggedIn()) {
            liff.login();
            return;
        }
    } catch (e) {
        document.querySelectorAll(".ss_ll_lf_loading")[0].setAttribute("data-ss_lf_disp","false");
        document.querySelectorAll(".ss_ll_lf_main_row")[0].setAttribute("data-ss_lf_disp","true");
        /*alert("エラー発生:\n" + e);*/
    }

    const ss_ll_idt = liff.getIDToken();

    try {
        const resp = await fetch("https://13dfs9ehk6.execute-api.ap-northeast-1.amazonaws.com/line-sso", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({id_token: ss_ll_idt})
        });
        if (!resp.ok) {
            /*alert("SSOに失敗しました")*/
            const data = await resp.text();
            if(data == "link not found"){
                location.href = "/";
            }else{
                document.querySelectorAll(".ss_ll_lf_loading")[0].setAttribute("data-ss_lf_disp","false");
                document.querySelectorAll(".ss_ll_lf_main_row")[0].setAttribute("data-ss_lf_disp","true");
            };
            return
        };
        const data = await resp.json();
        if (!data.redirect_url) {
            /*alert("SSOトークン生成に失敗しました")*/
            document.querySelectorAll(".ss_ll_lf_loading")[0].setAttribute("data-ss_lf_disp","false");
            document.querySelectorAll(".ss_ll_lf_main_row")[0].setAttribute("data-ss_lf_disp","true");
            return
        }
        if(slpr_cnf_v == "true"){
            location.href = data.redirect_url;
        }else{
            liff.openWindow({url: data.redirect_url, external: true});
            setTimeout(() => {liff.closeWindow();}, 300);
        };
    } catch (e) {
        document.querySelectorAll(".ss_ll_lf_loading")[0].setAttribute("data-ss_lf_disp","false");
        document.querySelectorAll(".ss_ll_lf_main_row")[0].setAttribute("data-ss_lf_disp","true");
        /*alert("エラー発生:\n" + e);*/
    }
};

document.querySelectorAll(".ss_ll_mr_hrf")[0].addEventListener("click",() => {
    liff.openWindow({url: "/", external: true});
    setTimeout(() => {liff.closeWindow();}, 300);
});